import { Tween, Easing } from '@tweenjs/tween.js';
import AnimationClip from '../AnimationClip';
import Point from '../../../Utility/Point';
import { delay } from '../../../Utility/Task/TaskQueue';
import GameObject from '../../../GameObject/GameObject';
import { Random } from '../../../Utility/Random';
import { DEG_TO_RAD } from 'pixi.js';
import ElementComponent from '../../../Component/UI/Element';

export class RewardPopIn extends AnimationClip {
    private isPlaying: boolean = true;
    private fieldId: string;

    public *execute(
        reward: GameObject,
        meta?: { delay?: number }
    ): IterableIterator<number> {
        meta = meta || { delay: 0 };
        meta.delay = meta.delay || 0;
        yield* delay(meta.delay);
        // Choose a random size for the reward item
        const baseScale: number = Random.value(0.75, 1);

        const wiggleTween: Tween = this.createWiggleTween(reward, 15, 100);
        const scaleOne: Tween = this.createScaleTween(
            reward,
            new Point(1.3 * baseScale, 1.3 * baseScale),
            333
        );
        const scaleTwo: Tween = this.createScaleTween(
            reward,
            new Point(0.7 * baseScale, 0.7 * baseScale),
            250
        );
        const scaleThree: Tween = this.createScaleTween(
            reward,
            new Point(baseScale, baseScale),
            333
        );

        scaleOne.chain(scaleTwo);
        scaleTwo.chain(scaleThree);
        scaleThree.onComplete(() => {
            wiggleTween.stop();
            this.isPlaying = false;
        });

        wiggleTween.start(this.elapsedTime);
        scaleOne.start(this.elapsedTime);

        while (this.isPlaying) {
            yield;
        }
    }

    private createScaleTween(
        gameObject: GameObject,
        scale: Point,
        duration: number
    ): Tween {
        const element: ElementComponent = gameObject.getComponent(
            ElementComponent
        );

        return this.getTween(element.scale)
            .to({ x: scale.x, y: scale.y }, duration)
            .easing(Easing.Sinusoidal.Out);
    }

    private createWiggleTween(
        gameObject: GameObject,
        degree: number,
        duration: number
    ): Tween {
        const element: ElementComponent = gameObject.getComponent(
            ElementComponent
        );

        return this.getTween(element)
            .repeat(Infinity)
            .yoyo(true)
            .easing(Easing.Sinusoidal.Out)
            .to({ rotation: DEG_TO_RAD * degree }, duration);
    }
}
